import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { PersonChip } from './PersonChip';
import type { DraftSelectOption } from './EditableDraftTable';

interface MemberLike {
  firstName: string;
  lastName: string;
  email: string;
}

/**
 * The one person-select option shape of the wizard tables: email as the
 * stored value, "Name — email" as the searchable label, PersonChip as the
 * rendered row/trigger content.
 */
export function buildMemberOptions(members: MemberLike[] | undefined): DraftSelectOption[] {
  return (members ?? []).map((member) => {
    const name = `${member.firstName} ${member.lastName}`;
    return {
      value: member.email,
      label: `${name} — ${member.email}`,
      display: <PersonChip name={name} size={22} />
    };
  });
}

/**
 * Red "Benutzer nicht gefunden" state for person selects whose imported
 * email resolved to no member (design's unresolved-owner cell).
 */
export function UserNotFoundBadge() {
  const { t } = useTranslation();
  return (
    <span className="flex min-w-0 items-center gap-1.75">
      <span className="flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full bg-danger-solid/12 text-danger">
        <X className="h-3 w-3" strokeWidth={2.4} />
      </span>
      <span className="truncate text-xs text-danger">
        {t('initialSetup.draftTable.userNotFound')}
      </span>
    </span>
  );
}
